<div
    #selectContainer
    class="custom-select z-20"
    (click)="toggleSelect()">
    <div
        #selectDiv="cdkOverlayOrigin"
        cdk-overlay-origin
        class="relative px-3 h-12 flex flex-row justify-between flex-nowrap items-center rounded-lg"
        id="select-div">
        <div
            class="truncated !m-0 text-base flex items-center gap-2 w-full text-outline"
            id="selected-option">
            {{ label() }}
        </div>

        <div class="flex flex-row items-center pl-5">
            <fa-icon
                class="transition duration-200 ease-in-out"
                size="sm"
                [class.expanded]="isOpen()"
                [fixedWidth]="true"
                [icon]="['fas', 'caret-down']" />
        </div>
    </div>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayOrigin]="selectDiv"
    [cdkConnectedOverlayPositions]="openUp() ? positionsUp : positionsDown"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayScrollStrategy]="scroll.reposition()"
    (overlayOutsideClick)="closeDropdown()"
    (positionChange)="onPositionChange($event)">
    <div
        #selectOptions
        class="select-options"
        [style.min-width.px]="dropdownWidth()">
        <div
            class="overflow-y-auto"
            [ngStyle]="{ 'max-height.px': dropdownMaxHeight }">
            @for (option of sortedOptions(); track option.label) {
                <div
                    #selectOptionElement
                    class="option px-4 py-2 flex flex-row items-center">
                    <p class="truncated !m-0 text-sm flex-1 readonly-option-label">
                        {{ option.label }}
                    </p>
                </div>
            }
        </div>
    </div>
</ng-template>
